import { render, staticRenderFns } from "./HomeCarousel.vue?vue&type=template&id=1b08354b&scoped=true&"
import script from "./HomeCarousel.vue?vue&type=script&lang=js&"
export * from "./HomeCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HomeCarousel.vue?vue&type=style&index=0&id=1b08354b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b08354b",
  null
  
)

export default component.exports